import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import CompleteProductList from './components/CompleteProductList';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lista-completa" element={<CompleteProductList />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
